/**
 * @flow
 * @relayHash 6d7122a7e22417f2b99691a1bb965a5f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POReviewFormCustomersQueryVariables = {|
  search?: ?string
|};
export type POReviewFormCustomersQueryResponse = {|
  +customers: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +name: string,
        +shippingAddressLine1: ?string,
        +shippingAddressLine2: ?string,
        +shippingAddressCity: ?string,
        +shippingAddressState: ?string,
        +shippingAddressZip: ?string,
      |}
    |}>
  |}
|};
export type POReviewFormCustomersQuery = {|
  variables: POReviewFormCustomersQueryVariables,
  response: POReviewFormCustomersQueryResponse,
|};
*/


/*
query POReviewFormCustomersQuery(
  $search: String
) {
  customers(first: 50, search: $search) {
    edges {
      node {
        id
        name
        shippingAddressLine1
        shippingAddressLine2
        shippingAddressCity
        shippingAddressState
        shippingAddressZip
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "customers",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 50
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "CustomerConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CustomerEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Customer",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressLine1",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressLine2",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressCity",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressState",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressZip",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "POReviewFormCustomersQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "POReviewFormCustomersQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "POReviewFormCustomersQuery",
    "id": null,
    "text": "query POReviewFormCustomersQuery(\n  $search: String\n) {\n  customers(first: 50, search: $search) {\n    edges {\n      node {\n        id\n        name\n        shippingAddressLine1\n        shippingAddressLine2\n        shippingAddressCity\n        shippingAddressState\n        shippingAddressZip\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'af0902599493bd5a613538eaa4f3468c';
module.exports = node;
